module.exports = __webpack_public_path__ + "img/Perfect-Attendance.80997342.png";